import Http from 'axios'
const axios = Http.create()
const BASE_URL = `live/api/v1/enterprise`
const RADAR_URL = `live/api/v1/examination/trade/radar`
const TRADE_BASE_URL = `live/api/v1/trade/radar`
import configInterceptor from '@/service/interceptor'
configInterceptor(axios)
export default {
  // 搜索主主体
  search (thirdQueryId) {
    return axios.post(`${BASE_URL}/search`, {
      thirdQueryId,
      pageNum: 1
    })
  },
  getTrades (tradeId = '') {
    return axios.get(`${RADAR_URL}/${tradeId}`)
  },
  lawPolicy (tradeName, params) {
    return axios.get(`${RADAR_URL}/${tradeName}/lawPolicys`, {
      params
    })
  },
  qualifications (tradeName, params) {
    return axios.get(`${RADAR_URL}/${tradeName}/qualifications`, {
      params
    })  },
  // 根据检索条件获取searchKey
  getSearchKey (params) {
    return axios.post(`${RADAR_URL}/query`, params)
  },
  // 根据searchkey 和fields 获取图标数据GET /api/office/v1/trade/radar/statistic
  getRadarChart (params) {
    return axios.get(`${RADAR_URL}/statistic`, {
      params
    })
  },
  getRadarChartMore (params) {
    return axios.get(`${RADAR_URL}/statisticMore`, {
      params
    })
  }
}
